/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateDestinationRequestMetadata } from './CreateDestinationRequestMetadata';
import {
    CreateDestinationRequestMetadataFromJSON,
    CreateDestinationRequestMetadataFromJSONTyped,
    CreateDestinationRequestMetadataToJSON,
} from './CreateDestinationRequestMetadata';
import type { CreateDestinationRequestSecrets } from './CreateDestinationRequestSecrets';
import {
    CreateDestinationRequestSecretsFromJSON,
    CreateDestinationRequestSecretsFromJSONTyped,
    CreateDestinationRequestSecretsToJSON,
} from './CreateDestinationRequestSecrets';

/**
 * 
 * @export
 * @interface CreateDestinationRequest
 */
export interface CreateDestinationRequest {
    /**
     * Name for the new destination. Must be unique within the project and can only contain letters, numbers and dashes.
     * @type {string}
     * @memberof CreateDestinationRequest
     */
    name: string;
    /**
     * The type of the destination. For `slack`, set `metadata.url` to a Slack incoming webhook URL. The warehouse and message-queue types (`clickhouse`, `snowflake`, `bigquery`, `redshift`, `sqs`, `pubsub`, `rabbitmq`, `azureservicebus`) are configured via the `metadata` and `secrets` fields documented below.
     * @type {string}
     * @memberof CreateDestinationRequest
     */
    type: CreateDestinationRequestTypeEnum;
    /**
     * 
     * @type {CreateDestinationRequestSecrets}
     * @memberof CreateDestinationRequest
     */
    secrets?: CreateDestinationRequestSecrets;
    /**
     * 
     * @type {CreateDestinationRequestMetadata}
     * @memberof CreateDestinationRequest
     */
    metadata: CreateDestinationRequestMetadata;
}


/**
 * @export
 */
export const CreateDestinationRequestTypeEnum = {
    Webhook: 'webhook',
    Kinesis: 'kinesis',
    S3: 's3',
    Slack: 'slack',
    Clickhouse: 'clickhouse',
    Snowflake: 'snowflake',
    Bigquery: 'bigquery',
    Redshift: 'redshift',
    Sqs: 'sqs',
    Pubsub: 'pubsub',
    Rabbitmq: 'rabbitmq',
    Azureservicebus: 'azureservicebus'
} as const;
export type CreateDestinationRequestTypeEnum = typeof CreateDestinationRequestTypeEnum[keyof typeof CreateDestinationRequestTypeEnum];


/**
 * Check if a given object implements the CreateDestinationRequest interface.
 */
export function instanceOfCreateDestinationRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "metadata" in value;

    return isInstance;
}

export function CreateDestinationRequestFromJSON(json: any): CreateDestinationRequest {
    return CreateDestinationRequestFromJSONTyped(json, false);
}

export function CreateDestinationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDestinationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'type': json['type'],
        'secrets': !exists(json, 'secrets') ? undefined : CreateDestinationRequestSecretsFromJSON(json['secrets']),
        'metadata': CreateDestinationRequestMetadataFromJSON(json['metadata']),
    };
}

export function CreateDestinationRequestToJSON(value?: CreateDestinationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'type': value.type,
        'secrets': CreateDestinationRequestSecretsToJSON(value.secrets),
        'metadata': CreateDestinationRequestMetadataToJSON(value.metadata),
    };
}

